// Chat widget modul: sendInfoQuestion public_widget_token-nel

import { apiCall } from './api.js';

async function parseWidgetResponse(response: Response): Promise<any> {
    const contentType = response.headers.get('content-type') || '';
    const isSse = contentType.includes('text/event-stream');
    if (!isSse) {
        return response.json();
    }

    const raw = await response.text();
    let text = '';
    let sources: any[] = [];
    let traceId = '';

    const lines = raw.split(/\r?\n/);
    for (const line of lines) {
        if (!line.startsWith('data:')) continue;
        const payload = line.slice(5).trim();
        if (!payload || payload === '[DONE]') continue;

        try {
            const evt = JSON.parse(payload);
            if (evt?.event_type === 'header') {
                traceId = evt?.data?.trace_id || traceId;
            }
            if (evt?.event_type === 'delta') {
                text += evt?.data?.text || '';
            }
            if (evt?.event_type === 'footer') {
                if (Array.isArray(evt?.data?.sources)) {
                    sources = evt.data.sources;
                }
            }
        } catch {
            // ignore malformed line
        }
    }

    return {
        text: text || 'Nincs válasz.',
        sources,
        trace_id: traceId || undefined,
    };
}

async function sendInfoQuestion(text: string, sessionId: string, tokenId: string): Promise<any> {
    const response = await apiCall('/widget/chat', {
        method: 'POST',
        body: {
            token_id: tokenId,
            session_id: sessionId,
            text,
        },
    });
    return parseWidgetResponse(response);
}

export { sendInfoQuestion };
